import createReactComponent from '../createReactComponent';
export default createReactComponent(
  'circuit-ground-digital',
  'IconCircuitGroundDigital',
  [
    ['path', { d: 'M12 13v-10', key: 'svg-0' }],
    ['path', { d: 'M12 21l-6 -8h12z', key: 'svg-1' }],
  ],
);
